export default function VendorResourcesDirective() {
  return {
    template: require('./vendor-resources.html'),
    scope: {
      assessmentId: '=',
      status: '@',
    },
    controller: 'VendorResourcesController',
    controllerAs: 'vendorResourcesVM',
    bindToController: true,
    replace: true,
  };
}
